<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Create affiliate'"></page-title>
    </div>

    <div>
      <!-- <a mat-stroked-button routerLink="/affiliates">Back to affiliates</a> -->
      <button matButton="filled" type="button" (click)="sharedUtils.navigateTo('/affiliates')">
        <mat-icon>arrow_back</mat-icon>
        Back to affiliates
      </button>
    </div>
  </div>

  <affiliate-form
    title="Affiliate details"
    submitLabel="Create affiliate"
    [busy]="affiliateStore.saving()"
    [genders]="lookupStore.items('GENDER')"
    [languages]="lookupStore.items('LANGUAGE')"
    [religions]="lookupStore.items('RELIGION')"
    [affiliateDisciplines]="lookupStore.items('AFFILIATE_DISCIPLINE')"
    [provinces]="lookupStore.items('PROVINCE')"
    (submitted)="onSubmit($event)" />
</section>
